import { React, styled, mq } from 'x'
import { compose, lifecycle, withState, withHandlers } from 'recompose'
import { useDidMount } from 'hooks/useDidMount'

const Container = styled.div`
  padding: 80px 0 00;
`

const Widget = styled.div`
  position: relative;

  iframe {
    position: relative;
    z-index: 2;
  }

  @media screen and (min-width: 420px) .trustpilot-widget #trust-score {
    font-size: 24px !important;
  }
`

const loadTrustpilot = () => {
  const script = document.createElement('script')

  script.src =
    '//widget.trustpilot.com/bootstrap/v5/tp.widget.sync.bootstrap.min.js'
  script.type = 'text/javascript'
  script.async = 'true'

  document.head.appendChild(script)
}

/*
const enhance = compose(
  withHandlers(() => {

    return {}
  }
)
*/

const enhance = compose(
  withHandlers({
    setRef: (props) => (ref) => {
      if (!ref) {
        return
      }

      // console.log('setRef', props, ref)

      const observer = new IntersectionObserver((entries) => {
        // console.log('!!!', entries[0].intersectionRatio)
        if (entries[0].intersectionRatio > 0) {
          if (typeof window.Trustpilot === 'undefined') {
            // console.log('loadTrustpilot')
            loadTrustpilot()
          } else {
            window.Trustpilot.loadFromElement(ref)
          }
        }
      })

      observer.observe(ref)

      /*
      if (typeof window.Trustpilot === 'undefined') {
        loadTrustpilot()
      } else {
        window.Trustpilot.loadFromElement(ref)
      }
      */
    },
    /*
     */
  })
)

const TrustpilotWidget = (props) => {
  return (
    <Container>
      <Widget
        ref={props.setRef}
        data-locale={props.globalData.language.hreflang}
        className="trustpilot-widget"
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="5e6ae02f44891200011a2c26"
        data-style-height="80px"
        data-style-width="100%"
        data-theme="light"
        data-text-color="#2A2D58"
      />
    </Container>
  )
}

export default enhance(TrustpilotWidget)
